/* eslint-disable no-unused-vars */
import React from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Logo from "../assets/LOGO.svg";
import Timer from "../components/Timer";
toast.configure();
const Home = ({
  days,
  hours,
  minutes,
  seconds,
  difference,
  startTime,
  endTime,
}) => {
  return (
    <div className="home px-4">
      <div className="py-10">
        <img src={Logo} className=" max-w-[300px] mx-auto" alt="" />
      </div>
      <div className="min-h-[70vh] flex justify-center items-center">
        <div>
          <Timer
            days={days}
            hours={hours}
            minutes={minutes}
            seconds={seconds}
            startTime={startTime}
            endTime={endTime}
            difference={difference}
          />
          <div>
            <h2 className="font-bold text-white italic text-center mb-4 text-lg">
              CHOOSE YOUR PAYMENT METHOD
            </h2>
            <div className=" grid grid-flow-col gap-4">
              <Link
                to="/swap"
                className="orange-gradient btn px-6 text-sm flex justify-center items-center sm:text-base text-center sm:px-10 py-1.5 font-bold text-white"
              >
                BUY WITH METAMASK
              </Link>
              <Link
                to="/howto"
                className=" blue-gradient btn px-6 text-sm flex justify-center items-center sm:text-base text-center sm:px-10 py-1.5 font-bold text-white"
              >
                BUY WITH WALLET
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
